import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  cartItems: [],
};

export const addToCartSlice = createSlice({
  name: "AddToCartReducer",
  initialState,
  reducers: {
    addItems: (state, action) => {
      state.cartItems = [...state.cartItems, action.payload];
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  addItems,
  removeItems,
} = addToCartSlice.actions;

export default addToCartSlice.reducer;
